import type { BannerCtaTarget } from '@/lib/banner/useBanners';

/**
 * Resolve a banner CTA target to an existing app route, reusing the lobby URL
 * contract (`?category=` / `?subCategory=`, see {@link useAppSearchParams}) and
 * the event page route (`/events/:eventId`, see AppRouter). No new routes are
 * invented — these are the same destinations the category bar and notification
 * CTAs already navigate to.
 */
export function bannerCtaPath(target: BannerCtaTarget): string {
  switch (target.kind) {
    case 'EVENT':
      return `/events/${target.id}`;
    case 'CATEGORY':
      return `/?category=${encodeURIComponent(target.id)}`;
    case 'SUBCATEGORY':
      return `/?subCategory=${encodeURIComponent(target.id)}`;
  }
}
